import { render, staticRenderFns } from "./ConfirmPasswordForm.vue?vue&type=template&id=a4452cf4&"
import script from "./ConfirmPasswordForm.vue?vue&type=script&lang=js&"
export * from "./ConfirmPasswordForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports